<div class="toggleBtn" (click)="toggleOpen()">
  <div
    class="generic-tooltip"
    [attr.data-tooltip]="'Tag filters' | translate"
  ></div>
</div>
<div class="container">
  <h3>{{ 'Tag filters' | translate }}</h3>
  <div class="tags-container">
    <header>
      <h3>{{ 'Assets' | translate }}</h3>
    </header>
    <div class="scroll-container">
      <div *ngFor="let group of tags; let i = index" class="tag-group">
        <p *ngIf="tags.length > 1">{{ group.label }}</p>
        <div class="tags-grid">
          <button
            *ngIf="!politis"
            (click)="clearGroup($event, i)"
            [class.selected]="isAllSelected(i)"
          >
            {{ 'All' | translate }}
          </button>
          <button
            *ngIf="politis"
            (click)="clearGroup($event, i)"
            [class.selected]="isAllSelected(i)"
          >
            {{ 'ALL' | translate }}
          </button>
          <button
            *ngFor="let tag of group.tags"
            (mouseup)="selectTag($event, tag, i)"
            [class.selected]="isTagSelected(tag, i)"
          >
            {{ tag.label || tag.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="reach-filter">
    <header>
      <h3>{{ 'By Reach' | translate }}</h3>
      <button
        (click)="applyReachFilter()"
        [class.disabled]="applyFilterDisabled"
      >
        {{ 'Apply' | translate }}
      </button>
    </header>
    <div class="slider-container">
      <ngx-slider
        *ngIf="stats"
        [(value)]="reachFilter[0]"
        [(highValue)]="reachFilter[1]"
        [options]="{
          floor: stats.min,
          ceil: stats.max,
          translate: sliderFormatFn,
          animate: false,
        }"
      ></ngx-slider>
    </div>
  </div>
</div>
